import React from 'react';
import _ from 'lodash';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/form.module';

export const BusinessDetailsContainer = ({ selectedVenture, onInnerFormChange }: any) => {
    return (
        <>
            <AccordionContainer
                 child={
                   <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                     
                  <InputContainer
                         label="Business Name"
                         name="BusinessName"
                            isDisabled
                         onValueChange={(event: any) => {
                           onInnerFormChange(
                             event.target.value,
                             'Account.Name',
                             selectedVenture?.Business
                           )
                         }}
                         type="text"
                         value={selectedVenture?.Business?.BusinessName}
                     />

                      <InputContainer
                         label="Business Email"
                         name="BusinessEmail"
                            isDisabled
                         onValueChange={(event: any) => {
                           onInnerFormChange(
                             event.target.value,
                             'Account.Name',
                             selectedVenture?.Business
                           )
                         }}
                         type="text"
                         value={selectedVenture?.Business?.BusinessEmail}
                     />

                        <InputContainer
                         label="Business PhoneNumber"
                         name="BusinessPhoneNumber"
                         isDisabled
                         onValueChange={(event: any) => {
                           onInnerFormChange(
                             event.target.value,
                             'Account.Name',
                             selectedVenture?.Business
                           )
                         }}
                         type="text"
                         value={selectedVenture?.Business?.BusinessPhoneNumber}
                     />
                  
               </div>
            }
            expandedPanel="accountInfo"
            headerTitle="Account Info"
           />

        </>
    )
}
export default BusinessDetailsContainer;